import { createSessionWatcherSaga } from './createSessionBlock.saga'
import { destroySessionBlockWatcherSaga } from './destroySessionBlock.saga'
import { editSessionBlockWatcherSaga } from './editSessionBlock.saga'

export const sessionSagas = [
  createSessionWatcherSaga(),
  destroySessionBlockWatcherSaga(),
  editSessionBlockWatcherSaga(),
]

export default sessionSagas
